import { OutfitType, OrderStatus } from './types';

export const MEASUREMENT_FIELDS: Record<OutfitType, { label: string; key: string }[]> = {
  [OutfitType.Haut]: [
    { label: 'Tour de Poitrine', key: 'tourPoitrine' },
    { label: 'Tour Dessous Poitrine', key: 'tourDessousPoitrine' },
    { label: 'Tour de Taille', key: 'tourTailleHaut' },
    { label: 'Carrure Devant', key: 'carrureDevant' },
    { label: 'Carrure Dos', key: 'carrureDos' },
    { label: 'Longueur Épaule', key: 'longueurEpaule' },
    { label: 'Tour de Cou', key: 'tourCou' },
    { label: 'Longueur Manche', key: 'longueurManche' },
    { label: 'Tour de Bras', key: 'tourBras' },
    { label: 'Tour de Poignet', key: 'tourPoignet' },
    { label: "Tour d'Emmanchure", key: 'tourEmmanchure' },
    { label: 'Hauteur Poitrine', key: 'hauteurPoitrine' },
    { label: 'Écartement Poitrine', key: 'ecartementPoitrine' },
    { label: 'Longueur Corsage Devant', key: 'longueurCorsageDevant' },
    { label: 'Longueur Corsage Dos', key: 'longueurCorsageDos' },
    { label: 'Longueur Totale (Haut)', key: 'longueurTotaleHaut' },
  ],
  [OutfitType.Bas]: [
    { label: 'Tour de Taille', key: 'tourTailleBas' },
    { label: 'Tour de Hanches', key: 'tourHanches' },
    { label: 'Hauteur Taille-Hanches', key: 'hauteurTailleHanches' },
    { label: 'Longueur Jambe', key: 'longueurJambe' },
    { label: 'Tour de Cuisse', key: 'tourCuisse' },
    { label: 'Tour de Genou', key: 'tourGenou' },
    { label: 'Tour de Cheville', key: 'tourCheville' },
    { label: 'Fourche Devant', key: 'fourcheDevant' },
    { label: 'Fourche Dos', key: 'fourcheDos' },
  ],
  [OutfitType.Robe]: [
    { label: 'Tour de Poitrine', key: 'tourPoitrine' },
    { label: 'Tour Dessous Poitrine', key: 'tourDessousPoitrine' },
    { label: 'Tour de Taille', key: 'tourTailleRobe' },
    { label: 'Tour de Hanches', key: 'tourHanches' },
    { label: 'Carrure Devant', key: 'carrureDevant' },
    { label: 'Carrure Dos', key: 'carrureDos' },
    { label: 'Longueur Épaule', key: 'longueurEpaule' },
    { label: 'Tour de Cou', key: 'tourCou' },
    { label: 'Longueur Manche', key: 'longueurManche' },
    { label: 'Tour de Bras', key: 'tourBras' },
    { label: 'Tour de Poignet', key: 'tourPoignet' },
    { label: "Tour d'Emmanchure", key: 'tourEmmanchure' },
    { label: 'Hauteur Poitrine', key: 'hauteurPoitrine' },
    { label: 'Écartement Poitrine', key: 'ecartementPoitrine' },
    { label: 'Longueur Corsage Devant', key: 'longueurCorsageDevant' },
    { label: 'Longueur Corsage Dos', key: 'longueurCorsageDos' },
    { label: 'Hauteur Taille-Hanches', key: 'hauteurTailleHanches' },
    { label: 'Hauteur Taille-Genou', key: 'hauteurTailleGenou' },
    { label: 'Longueur Totale (Robe)', key: 'longueurTotaleRobe' },
  ],
  [OutfitType.Jupe]: [
    { label: 'Tour de Taille', key: 'tourTailleJupe' },
    { label: 'Tour de Hanches', key: 'tourHanches' },
    { label: 'Hauteur Taille-Hanches', key: 'hauteurTailleHanches' },
    { label: 'Hauteur Taille-Genou', key: 'hauteurTailleGenou' },
    { label: 'Longueur Jupe', key: 'longueurJupe' },
  ],
  [OutfitType.Manteau]: [
    { label: 'Tour de Poitrine', key: 'tourPoitrine' },
    { label: 'Tour de Taille', key: 'tourTailleManteau' },
    { label: 'Tour de Hanches', key: 'tourHanches' },
    { label: 'Carrure Devant', key: 'carrureDevant' },
    { label: 'Carrure Dos', key: 'carrureDos' },
    { label: 'Longueur Épaule', key: 'longueurEpaule' },
    { label: 'Tour de Cou', key: 'tourCou' },
    { label: 'Longueur Manche', key: 'longueurManche' },
    { label: 'Tour de Bras', key: 'tourBras' },
    { label: 'Tour de Poignet', key: 'tourPoignet' },
    { label: 'Longueur Totale (Manteau)', key: 'longueurTotaleManteau' },
  ],
  [OutfitType.Gilet]: [
    { label: 'Tour de Poitrine', key: 'tourPoitrine' },
    { label: 'Tour de Taille', key: 'tourTailleGilet' },
    { label: 'Carrure', key: 'carrure' },
    { label: 'Tour de Cou', key: 'tourCou' },
    { label: 'Longueur Gilet (Devant)', key: 'longueurGiletDevant' },
    { label: 'Longueur Gilet (Dos)', key: 'longueurGiletDos' },
  ],
  [OutfitType.Combinaison]: [
    { label: 'Tour de Poitrine', key: 'tourPoitrine' },
    { label: 'Tour de Taille', key: 'tourTaille' },
    { label: 'Tour de Hanches', key: 'tourHanches' },
    { label: 'Carrure', key: 'carrure' },
    { label: 'Longueur Épaule', key: 'longueurEpaule' },
    { label: 'Tour de Cou', key: 'tourCou' },
    { label: 'Longueur Manche', key: 'longueurManche' },
    { label: 'Tour de Bras', key: 'tourBras' },
    { label: 'Tour de Poignet', key: 'tourPoignet' },
    { label: 'Hauteur Poitrine', key: 'hauteurPoitrine' },
    { label: 'Écartement Poitrine', key: 'ecartementPoitrine' },
    { label: 'Longueur Corsage (Devant)', key: 'longueurCorsageDevant' },
    { label: 'Longueur Totale (Épaule-Sol)', key: 'longueurTotaleCombinaison' },
    { label: 'Longueur Jambe (Intérieur)', key: 'longueurJambeInterieur' },
    { label: 'Tour de Cuisse', key: 'tourCuisse' },
    { label: 'Tour de Genou', key: 'tourGenou' },
    { label: 'Tour de Cheville', key: 'tourCheville' },
    { label: 'Fourche Devant', key: 'fourcheDevant' },
    { label: 'Fourche Dos', key: 'fourcheDos' },
  ],
  [OutfitType.Kaftan]: [
    { label: 'Largeur Totale', key: 'largeurTotale' },
    { label: 'Longueur Totale', key: 'longueurTotaleKaftan' },
    { label: 'Longueur Manche (depuis cou)', key: 'longueurMancheCou' },
    { label: 'Largeur Encolure', key: 'largeurEncolure' },
    { label: 'Tour de Tête', key: 'tourTete' },
  ],
  [OutfitType.Corset]: [
    { label: 'Tour de Poitrine', key: 'tourPoitrine' },
    { label: 'Tour Dessous Poitrine', key: 'tourDessousPoitrine' },
    { label: 'Tour de Taille', key: 'tourTaille' },
    { label: 'Tour Hanches (hautes)', key: 'tourHanchesHautes' },
    { label: 'Hauteur Poitrine', key: 'hauteurPoitrine' },
    { label: 'Hauteur Sous Poitrine', key: 'hauteurSousPoitrine' },
    { label: 'Hauteur Côté', key: 'hauteurCote' },
  ],
  [OutfitType.Complet]: [
    // --- Veste ---
    { label: 'Tour de Poitrine', key: 'tourPoitrine' },
    { label: 'Tour de Taille (Veste)', key: 'tourTailleHaut' },
    { label: 'Tour de Hanches (Veste)', key: 'tourHanchesHaut' },
    { label: 'Carrure Devant', key: 'carrureDevant' },
    { label: 'Carrure Dos', key: 'carrureDos' },
    { label: 'Longueur Épaule', key: 'longueurEpaule' },
    { label: 'Tour de Cou', key: 'tourCou' },
    { label: 'Longueur Manche', key: 'longueurManche' },
    { label: 'Tour de Bras', key: 'tourBras' },
    { label: 'Tour de Poignet', key: 'tourPoignet' },
    { label: 'Longueur Veste', key: 'longueurTotaleHaut' },
    // --- Pantalon ---
    { label: 'Tour de Taille (Pantalon)', key: 'tourTailleBas' },
    { label: 'Tour de Hanches (Pantalon)', key: 'tourHanches' },
    { label: 'Longueur Jambe', key: 'longueurJambe' },
    { label: 'Tour de Cuisse', key: 'tourCuisse' },
    { label: 'Tour de Genou', key: 'tourGenou' },
    { label: 'Tour de Cheville', key: 'tourCheville' },
    { label: 'Fourche Devant', key: 'fourcheDevant' },
    { label: 'Fourche Dos', key: 'fourcheDos' },
  ],
   [OutfitType.Traditionnel]: [
    { label: 'Longueur Totale', key: 'longueurTotale' },
    { label: 'Largeur', key: 'largeur' },
    { label: 'Tour de Poitrine', key: 'tourPoitrine' },
    { label: 'Tour de Taille', key: 'tourTaille' },
    { label: 'Tour de Hanches', key: 'tourHanches' },
  ],
};

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  pending: 'A démarrer',
  in_progress: 'En cours',
  ready: 'Prêt',
  delivered: 'Livré',
  cancelled: 'Annulé',
};

export const ORDER_STATUS_OPTIONS = (Object.keys(ORDER_STATUS_LABELS) as OrderStatus[]).map((status) => ({
  value: status,
  label: ORDER_STATUS_LABELS[status],
}));
